import { Component, HostListener, inject, OnInit, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { INotification } from '../../../../core/models/INotification';
import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-header-notification',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class HeaderNotificationComponent implements OnInit {
  private notificationService = inject(NotificationService);
  private router = inject(Router);
  private authService = inject(AuthService);

  isOpen = signal<boolean>(false);
  
  // Expose service signals directly
  notifications = this.notificationService.notifications;
  unreadCount = this.notificationService.unreadCount;
  isLoadingNotifications = this.notificationService.isLoadingNotifications;
  isLoadingMore = this.notificationService.isLoadingMore;
  hasNextPage = this.notificationService.hasMorePages;

  ngOnInit(): void {
    // Notifications are managed by the service (SignalR + auto-load on init)
  }

  toggleDropdown(): void {
    const newState = !this.isOpen();
    this.isOpen.set(newState);
    if (newState && this.authService.isAuthenticated()) {
      this.notificationService.refreshNotifications();
    }
  }

  closeDropdown(): void {
    this.isOpen.set(false);
  }

  loadMoreNotifications(): void {
    this.notificationService.loadMoreNotifications().subscribe();
  }

  markAsRead(notification: INotification): void {
    if (!notification.isRead) {
      this.notificationService.markAsRead(notification.id).subscribe();
    }
  }

  markAllAsRead(): void {
    this.notificationService.markAllAsRead().subscribe();
  }

  handleNotificationClick(notification: INotification): void {
    this.markAsRead(notification);
    const route = this.notificationService.getNotificationRoute(notification);
    if (route) {
      this.router.navigate([route]);
      this.closeDropdown();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.notification-dropdown') && !target.closest('.notification-icon')) {
      this.closeDropdown();
    }
  }
}
